import React, { forwardRef, useImperativeHandle } from 'react';
import { useDrawers } from '@hooks/useDrawers';
import { useCurrentOrder } from '@hooks/useCurrentOrder';
import { Stopwatch } from '@commons/stopwatch';
import { useCronometreOrder } from '@hooks/useCronometreOrder';
import dayjs from 'dayjs';
import Loader from '@commons/loader';
import { OrdersDetailsItem } from '@modules/drawers/components/orders-details-item';
import { Button, CardFooter, Card, CardHeader } from '@nextui-org/react';
import { Icon } from '@iconify/react';
import { useForm, useFormContext } from 'react-hook-form';
import FormProvider, { RHFSelect } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { orderSchema, orderSchemaOptional } from '@/modules/orders/form/order/validation';
import { Order } from '@/modules/orders/types';
import { useFetch } from '@/modules/orders/hooks/useFetch';
import { createOrdersService } from '@/services';
import { errorOrders, translates } from '@/utils';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '@/routes/paths';
import { Button as ButtonPorky } from '@PorkyCol/button';
import { TWTextField } from '@commons/hook-form';
import { MenuItem } from '@mui/material';
import { Iconic } from '@/commons/iconic';



export const ShoppingCar = forwardRef((props, ref) => {
  const { data, onChangeLoading, loading, onClose } = useDrawers<any>();
  /* console.log('🚀 ~ ShoppingCar ~ data:', data?.data?.()); */
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const onCreateOrdersService = async (values: any) => {
    try {
      const resolve = await onSubmitCreateOrder(values);
      if (resolve.error) {
        const errorMessage =
          errorOrders[resolve?.error ?? resolve?.error.message] ?? 'Problemas Añadiendo Productos';
        enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });
      } else {
        navigate(PATH_DASHBOARD.orders.view(resolve?.id));
      }
    } catch (error) {
      const errorMessage = errorOrders[error?.error.message] ?? 'Problemas Añadiendo Productos';
      enqueueSnackbar(`${errorMessage.label ?? errorMessage} `, { variant: 'error' });

      if (error.data) enqueueSnackbar(`${error.data.name} `, { variant: 'info' });
      if (errorMessage.redirect) {
        navigate(PATH_DASHBOARD.orders.open_orders);
      }
      throw new Error(error);
    }
  };

  const methods = useForm({
    mode: 'all',
    resolver: yupResolver(data?.isAvailableVendor ? orderSchema : orderSchemaOptional),
    defaultValues: data?.data?.() ?? {},
  } as any);
  const {
    reset,
    handleSubmit,
    watch,
    setValue,
    formState: { isSubmitting, isValid },
  } = methods;
  const {
    isLoading,
    fetchValues: onSubmitCreateOrder,
    // data: dataCreateOrder,
  } = useFetch({
    fetchFunction: createOrdersService,
    getData: true,
  });
  const onSubmit = async (dataForm: any) => {
    try {
      const { items, ...rest } = dataForm;
      console.log('🚀 ~ CreateSimpleOrder ~ dataForm', dataForm);
      const valuesFormatted = dataForm.items.map((item: any) => {
        if (item.quantity + item.discountNumber < 1) {
          throw null;
        }

        const discountFlag = item.discountNumber > 0 && item.discount > 0;
        return {
          productId: Number(item.id),
          quantity: Number(item.quantity),
          description: item.description,
          discount: {
            discount: Number(discountFlag ? item.discount : 0),
            quantity_discount: Number(discountFlag ? item.discountNumber : 0),
          },
        };
      });
      console.log('🚀 ~ CreateSimpleOrder ~ valuesFormatted', {
        ...rest,
        ordersDetails: valuesFormatted,
      });
      await onCreateOrdersService({ ...rest, ordersDetails: valuesFormatted });
    } catch (error) {
      const errorMessage = new Error(error?.message);

      throw errorMessage;
    }
  };
  const items: any = watch()?.items ?? [];
  console.log("🚀 ARREGLO WATCH~~~~~~items:", items)

  useImperativeHandle(ref, () => {
    return {
      syncForms: () => {

        data?.setItems(items);
    },
  }}, [items]);
  if (loading) {
    return <Loader />;
  }
  
  const handlePressMinus = (index: any, productId: string) => {
    const existingProduct = items[index];

    if (existingProduct) {
      if (existingProduct.quantity > 1) {
        setValue(
          `items[${index}].quantity`,
          // eslint-disable-next-line no-unsafe-optional-chaining
          items[index]?.quantity - 1 || 1
        );
      } else {
        setValue(
          'items',
          items.filter((p: any, i: any) => i !== index)
        );
      }
    }
  };
  const handlePressMax = (index: any, productId: string) => {
    const existingProduct = items[index];
    if (existingProduct) {
      return setValue(
        `items[${index}].quantity`,
        // eslint-disable-next-line no-unsafe-optional-chaining
        items[index]?.quantity + 1 || 1
      );
    }
  };
console.log(data)
  return (
    <FormProvider 
    style={{ 
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: "#ffffff",
      boxShadow:'0px 4px 6px rgba(0, 0, 0, 0.1)',
      background:'#ffffff',
      opacity: '1',
     }}
    methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <div className='pt-10 px-3 '>

       {data?.isAvailableVendor ? (
            <RHFSelect
              name="vendor"
              size="small"
              label={data?.isFoodCompany ? translates.waiter : 'Vendedor'}
              sx={{ height: '100%' }}
              InputProps={{ style: { height: '100%' } }}
              InputLabelProps={{ shrink: true }}
            >
              {data?.users?.map?.((service: any) => (
                <MenuItem key={service.id + service.name} value={service.id}>
                  {service.name}
                </MenuItem>
              ))}
            </RHFSelect>
          
  
          ): null}
      </div>
      <div className="flex flex-col py-5 justify-center px-1 items-center gap-5 m-2 relative">
          {items?.map((item: any, index: number) => (
            <div className='flex flex-row w-full'>
            <div className='w-2/3 flex flex-col text-wrap flex-wrap'>
              <p className="font-semibold p-0 m-0 h-fit break-words">{item.name}</p>
              
              {item?.description && (
                <caption className="text-xs text-default-400  w-3/4 break-words h-auto text-left">{item.description}</caption>
              )}
              <p className="text-sm text-default-800 font-bold">{item.price.toLocaleString()} </p>
            
            
            </div>

              <div className="flex items-center justify-end gap-3 w-1/3 ">
                <Button
                  isIconOnly
                  className="rounded-full h-5 w-5 min-w-5"
                  color="primary"
                  onPress={() => handlePressMinus(index, item.id)}
                >
                  -
                </Button>
                <span>{item.quantity}</span>
                <Button
                  isIconOnly
                  className="rounded-full h-5 w-5 min-w-5 flex justify-center items-center text-center p-0"
                  color="primary"
                  onPress={() => handlePressMax(index, item.id)}
                >
                  +
                </Button>
            </div>
            </div>

          ))}
      </div>
        
         
    <div className='m-2'>
      <TWTextField
            name="table"
            label={data?.isFoodCompany ? 'Mesa' : translates.table}
            placeholder={data?.isFoodCompany ? 'Mesa 01' : 'Nombre del cliente'}
          />
          <ButtonPorky
            type="submit"
            variant="solid"
            color="success"
            size="sm"
            loading={isLoading}
            disabled={!isValid}
            className=' m-2 back'
          >
            Crear orden
          </ButtonPorky>
          </div>
    </FormProvider>
  );
});
